/* Resolve live line keys before removal: discount changes can invalidate rendered keys. */
(() => {
  if (window.lanvinCartRemovalReady) return;
  window.lanvinCartRemovalReady = true;
  let busy = false;
  const base = window.Shopify?.routes?.root || '/';
  const signature = value => JSON.stringify(Object.entries(value || {}).sort(([a], [b]) => a.localeCompare(b)));
  const isGift = item => String(item.variant_id) === '41398267871304' || item.sku === 'GIFTWRAPPING______001F';
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-cart-remove]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    const row = button.closest('[data-input-item]');
    const buttons = [...document.querySelectorAll('[data-cart-remove]')];
    buttons.forEach(control => { control.disabled = true; });
    row?.setAttribute('aria-busy', 'true');
    row?.querySelector('[data-removal-error]')?.remove();
    try {
      const response = await fetch(`${base}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart unavailable');
      const current = await response.json();
      const properties = signature(JSON.parse(button.dataset.lineProperties || '{}'));
      const matches = current.items.filter(item => String(item.variant_id) === button.dataset.variantId && signature(item.properties) === properties);
      const indexed = current.items[Number(button.dataset.lineIndex) - 1];
      const target = matches.find(item => item.key === row?.dataset.key) ||
        (matches.length === 1 ? matches[0] : matches.find(item => item === indexed));
      if (!target) {
        if (matches.length === 0) { window.location.reload(); return; }
        throw new Error('ambiguous cart line');
      }
      const updates = { [target.key]: 0 };
      const body = { updates };
      const remainingRegular = current.items.filter(item => item.key !== target.key && !isGift(item));
      if (remainingRegular.length === 0) {
        current.items.filter(isGift).forEach(item => { updates[item.key] = 0; });
        body.attributes = { 'gift-wrapping': '', 'gift-cart-key': '', 'ギフトラッピング': '', '包装': '', '包装コード': '', 'ギフトメッセージ': '', 'ラッピング組み合わせのご要望': '' };
      } else if (isGift(target)) {
        body.attributes = { 'gift-wrapping': '', 'gift-cart-key': '', 'ギフトラッピング': '', '包装': '', '包装コード': '', 'ギフトメッセージ': '', 'ラッピング組み合わせのご要望': '' };
      }
      const result = await fetch(`${base}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      });
      if (!result.ok) throw new Error('removal failed');
      const updated = await result.json();
      if (updated.items.some(item => item.key === target.key)) throw new Error('line still present');
      window.location.reload();
    } catch (error) {
      busy = false;
      buttons.forEach(control => { control.disabled = false; });
      row?.removeAttribute('aria-busy');
      const message = document.createElement('p');
      message.dataset.removalError = '';
      message.setAttribute('role', 'alert');
      message.textContent = '商品を削除できませんでした。ページを再読み込みして、もう一度お試しください。';
      button.parentElement.appendChild(message);
    }
  }, true);
})();
